<template>
  <footer class="footer">
    <div class="footer-main">
      <!-- 左侧：Logo + 联系方式 -->
      <div class="footer-left">
        <div class="logo-box">
          <img
            src="@/assets/images/logo.png"
            alt="实验室 Logo"
            class="logo"
          />
        </div>
        <ul class="contact">
          <li>📍 地址：山东省烟台经济技术开发区长江路300号</li>
          <li>📞 电话：0535-2607930</li>
          <li>✉️ 邮箱：webeditor@amgm.ac.cn</li>
        </ul>
      </div>
      <!-- 中间：关于我们 -->
      <div class="footer-column">
        <h4>关于我们</h4>
        <router-link to="/about">实验室简介</router-link>
        <router-link to="/about/structure">组织架构</router-link>
        <router-link to="/about/leader">现任领导</router-link>
        <router-link to="/about/campus">园区风貌</router-link>
        <router-link to="/about/video">Video介绍</router-link>
        <router-link to="/about/contact">联系我们</router-link>
      </div>
      <!-- 中间：研究系统 -->
      <div class="footer-column">
        <h4>研究系统</h4>
        <router-link to="/research/platform">公共研发平台</router-link>
        <router-link to="/research/center">研究中心</router-link>
        <router-link to="/research/joint">联合研发中心</router-link>
        <router-link to="/research/service">公共测试服务平台</router-link>
      </div>
      <!-- 中间：新闻中心 -->
      <div class="footer-column">
        <h4>新闻中心</h4>
        <router-link to="/news/general">综合新闻</router-link>
        <router-link to="/announcement/notice">通知公告</router-link>
        <router-link to="/news/cooperation">合作交流</router-link>
        <router-link to="/news/science">科普动态</router-link>
        <router-link to="/news/party">党建文化</router-link>
      </div>
      <!-- 右侧：二维码 -->
      <div class="footer-right">
        <img
          src="@/assets/images/dbewm.jpg"
          alt="官方二维码"
          class="qrcode"
        />
        <p>先进材料实验室<br />官方手机版站</p>
        <div class="slogan">责任 · 奉献 · 创新 · 价值</div>
      </div>
    </div>
    <!-- 底部版权 -->
    <div class="footer-bottom">
      Copyright © 2021 烟台先进材料与绿色制造山东省实验室
      <br />
      鲁ICP备2021011066号-2 ｜ 鲁ICP备2021011066号-3 ｜ 鲁公网安备37069302889102
    </div>
  </footer>
</template>
<script>
export default {
  name: 'AppFooter'
}
</script>
<style scoped src="@/assets/styles/appfooter.css"></style>
